import { useState, useEffect } from 'react';
import './face-login.css';
import { global_var, faceLoginEndPoint } from "../../services/login-config.js";
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsexports from '../../aws-exports.js';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { Loader, ThemeProvider, useTheme, Flex, View, Alert} from '@aws-amplify/ui-react';
import {message } from 'antd';
import { trackEvent } from '../../analytics/analytics_login.js';

Amplify.configure(awsexports);


const FaceLogin = () => {

  async function authenticate(visitorImageName){
    const requestUrl = faceLoginEndPoint  + '?' + new URLSearchParams({
        objectKey : visitorImageName,
        "companyId" : global_var.companyId
    })
    return await fetch(requestUrl, {
        method:'GET',
        headers: {
            'Accept':'application/json',
            'Content-Type':'application/json'
        }
    }).then(response=> response.json()).then((data) => {
        return data;
    }).catch(error => {
      console.log(error)
  })
  }

  const [loading, setLoading] = useState(true);
  const [sessionId, setSessionId] = useState(null);
  const [createLivenessApiData, setCreateLivenessApiData] = useState(null);
  const [cameraAccessGranted, setCameraAccessGranted] = useState(false);

  const checkCameraAccess = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasCamera = devices.some(device => device.kind === 'videoinput');

      if (!hasCamera) {
        throw new Error('No camera found');
      }

      await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraAccessGranted(true);
    } catch (error) {
      setCameraAccessGranted(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkCameraAccess();
  }, []);

  const handleUserCancel = () => {
    setShowLiveness(false);
    setTimeout(() => setShowLiveness(true), 0);
    if (cameraAccessGranted) {
      fetchCreateLiveness()
    }
  };

  const handleAnalysisComplete = async () => {
    try {
      const response = await fetch(
        faceLoginEndPoint +`/GetFaceLivenessSessionResults?SessionId=${createLivenessApiData.sessionId}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.isLive) {
        let imageName = data.imageName;
        const response = await authenticate(imageName);
        if (response.Message === 'Success' && response.data && response.data.access_token) {
  
          let domainName = 'https://' + window.location.host.replace(/.login/g,'');
  
          if (response.data.active_user_data.fkRoleId === 3) {
            domainName += '#/home/redirect';
          } else {
            domainName += '/company/#/home/redirect';
          }
  
          domainName += '?access_token=' + response.data.access_token;
          if(global_var.dashboard_url && response.data.active_user_data? response.data.active_user_data.fkRoleId? response.data.active_user_data.fkRoleId !== 3: false  : false){
              domainName = 'https://' + global_var.dashboard_url + '?token=' + response.data.access_token
          }
  
          localStorage.setItem('token', response.data.access_token);

          trackEvent("face_login_handle_completed", {
            status: 'success'
          });

          window.location.href = domainName;
        } else if (response.Message === 'Person Not Found') {
          message.error('User not Found');
          trackEvent("face_login_handle_completed", {
            status: 'user_not_found'
          });
          handleUserCancel()
        } else {
          message.error('Face identification failed.Please try again');
          trackEvent("face_login_handle_completed", {
            status: 'face_identification_failed'
          });
          handleUserCancel()
        }
      } else {
        handleUserCancel()
        message.error('Face liveness detection failed.Please try again');
      }
      
    } catch (error) {
      handleUserCancel()
      message.error('Failed to fetch liveness session results')
    }
};

const [showLiveness, setShowLiveness] = useState(false);
  useEffect(() => {
    setShowLiveness(true);
  }, []);

  const fetchCreateLiveness = async () => {

    try {
      const response = await fetch(faceLoginEndPoint + '/createFaceLivenessSession', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
         action:'create'
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setCreateLivenessApiData(data);
      setSessionId(data.sessionId)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cameraAccessGranted) {
      fetchCreateLiveness();
    }
  }, [cameraAccessGranted]);


  const { tokens } = useTheme();
  const theme = {
    name: 'Face Liveness Example Theme',
    tokens: {
      colors: {
        background: {
          primary: {
            value: "#fff",
          },
          secondary: {
            value: tokens.colors.neutral['100'].value,
          },
        },
        font: {
          primary: {
            value: "#212529"
          },
        },
        brand: {
          primary: {
            '10': tokens.colors.teal['100'],
            '80': tokens.colors.teal['40'],
            '90': tokens.colors.teal['20'],
            '100': tokens.colors.teal['10'],
          },
        }
      },
    },
  };



  return (
    <>
      <div className='container-fluid'>
        {cameraAccessGranted ? (
          <div className='row main-background-faceLogin '>
            <ThemeProvider theme={theme}>
              <View>
                <Flex justifyContent='center'>
                  {loading ? (
                    <Loader />
                  ) : (
                    showLiveness && (
                      <FaceLivenessDetector
                        sessionId={sessionId}
                        region="ap-south-1"
                        onAnalysisComplete={handleAnalysisComplete}
                        onError={(error) => {
                          handleUserCancel()
                        }}
                        components={{
                          PhotosensitiveWarning: () => (
                            <Alert
                              variation="warning"
                              isDismissible={false}
                              hasIcon={true}
                              heading="Caution"
                            >
                              Please avoid masks and flashlights covering your face for better results.
                            </Alert>
                          ),
                        }}
                        onUserCancel={handleUserCancel}
                      />
                    )
                  )}
                </Flex>
              </View>
            </ThemeProvider>
          </div>
        ) : (
            <div className="centered-error">
              <div>
                <h1 style={{color:"#307D95"}}>Camera Access Required</h1>
                <p style = {{color:"#ddd"}}>Please enable your webcam to proceed with face login.</p>
              </div>
            </div>
        )}


      </div>



    </>
  );
}

export default FaceLogin;
